var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","align-center":""}},[_c('character-deleting-text',{attrs:{"character":_vm.character}}),_c('delete-button',{on:{"click":function($event){_vm.$emit('delete', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }